import React from 'react';
import { ModularButton } from '@components/ModularButton/ModularButton';
import { DocumentTypeLabel } from '@appTypes/testType';

export const DiscountPageBottomButtons = () => (
  <ModularButton
    primaryButton={{
      buttonText: 'Se medlemskapene våre',
      variant: 'secondary',
      link: {
        type: 'internalLink',
        data: {
          slug: 'medlemskap',
          parent: null,
          blank: false,
          title: 'Medlemskap',
          descriptionTitle: 'Medlemskap',
          type: DocumentTypeLabel.nafnoSiteStructure,
        },
      },
    }}
    secondaryButton={{
      buttonText: 'Se de unike NAF-fordelene',
      link: {
        type: 'internalLink',
        data: {
          slug: 'medlemsfordeler',
          parent: {
            slug: 'medlemskap',
          },
          blank: false,
          title: 'Medlemskapsfordeler',
          descriptionTitle: 'Medlemskapsfordeler',
          type: DocumentTypeLabel.benefitOverview,
          parameters: 'tabView=naf-tjenester',
        },
      },
    }}
  />
);
